import { render } from "./PostListActivity.vue?vue&type=template&id=449970e2"
import script from "./PostListActivity.vue?vue&type=script&lang=js"
export * from "./PostListActivity.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__